import { useEffect, useState, useRef } from 'react'
import { Button, Box } from '@mui/material'
import { MEETINGS } from 'routes/constants'
import { useTranslation } from 'react-i18next'

const ParseHtml = ({ html, ...containerProps }) => {
  const { t } = useTranslation()
  const buttonRef = useRef(null)
  const [muiButtonHTML, setMuiButtonHTML] = useState(undefined)

  useEffect(() => {
    setMuiButtonHTML(buttonRef?.current?.outerHTML)
  }, [buttonRef, html])

  return (
    <>
      {html && (
        <>
          <Box style={{ display: 'none' }}>
            <Button
              ref={buttonRef}
              variant='contained'
              color='secondary'
              href={MEETINGS}>
              {t('myTeam.elevateOneOnOne')}
            </Button>
          </Box>
          <Box
            dangerouslySetInnerHTML={{
              __html: html?.replace('{{oneOnOneButton}}', muiButtonHTML)
            }}
            className='journeyStepContentInnerHTML'
            {...containerProps}
          />
        </>
      )}
    </>
  )
}

export default ParseHtml
